import { Tooltip } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

interface SashProps {
  color?: string
  label: string
  backgroundColor: string
  tooltip?: string
}

const useStyles = makeStyles()(() => ({
  text: {
    marginLeft: '-8px',
    textTransform: 'uppercase',
  },
  sash: {
    position: 'absolute',
    width: '147px',
    boxShadow: '0px 0px 15px white',
    transform: 'rotate(323deg)',
    textAlign: 'center',
    transformOrigin: 'left bottom',
    left: 0,
    top: '70px',
  },
}))

const Sash: React.FC<React.PropsWithChildren<SashProps>> = (props) => {
  const { classes } = useStyles()
  const sashDiv = (
    <div
      className={classes.sash}
      style={{
        backgroundColor: props.backgroundColor,
        color: props.color || 'white',
      }}
    >
      <span className={classes.text}>{props.label}</span>
    </div>
  )

  return props.tooltip ? (
    <Tooltip
      title={props.tooltip}
      placement="right"
      // Negative margin is necessary to prevent the tooltip from being very far from the sash
      PopperProps={{
        style: {
          margin: -30,
        },
      }}
    >
      {sashDiv}
    </Tooltip>
  ) : (
    sashDiv
  )
}

export default Sash
